import { AxiosResponse } from 'axios';

import { closeModal as closeModalAction } from 'store/modals/actions';
import { store } from 'store/configureStore';

import { OnFulfilledResponsePropsType, ResponseHandler } from 'services/api/ApiClientService/types';

// Intercepts a fulfilled response and attaches additional data.
const onFulfilledResponse = ({
    onUpdateToken,
    headerTokenKey,
    serverErrorUrls,
    isServerErrorModalOpened,
}: OnFulfilledResponsePropsType): ResponseHandler => {
    return (response: AxiosResponse) => {
        const newToken = response.headers?.[headerTokenKey];

        if (newToken) {
            onUpdateToken && onUpdateToken(newToken as string);
            if (response.data && typeof response.data === 'object') {
                (response.data as any)[headerTokenKey] = newToken;
            }
        }

        const countryHeader = response.headers?.country;

        if (countryHeader && response.data && typeof response.data === 'object') {
            (response.data as any).country = countryHeader;
        }

        const url = response?.config?.url;

        if (url && serverErrorUrls.has(url)) {
            serverErrorUrls.delete(url);

            if (serverErrorUrls.size === 0 && isServerErrorModalOpened.current) {
                store.dispatch(closeModalAction());
                isServerErrorModalOpened.current = false;
            }
        }

        return response.data;
    };
};

export default onFulfilledResponse;
